import { TOGGLE_MENU_DISPLAY, UPDATE_PROFILE_DETAIL, INITIAL_PROFILE_DETAIL } from "../actionTypes";

const initialState = { 
	menuDisplay: false,
	profileDetail: {
		firstname: "",
		lastname: "",
		email: "",
	}
};

const toggleMenuDisplayReducer = (state, action) => {
	return {...state, menuDisplay: action.menuDisplay}
}

const updateProfileDetailReducer = (state, action) => {
	return {...state, profileDetail: action.profileDetail}
}

const initialProfileReducer = (state) => {
	return {...state, profileDetail: initialState.profileDetail}
}

const headerBar = (state = initialState, action) => {
	switch (action.type) {
		case TOGGLE_MENU_DISPLAY:
			return toggleMenuDisplayReducer(state, action)
		case UPDATE_PROFILE_DETAIL:
			return updateProfileDetailReducer(state,action)
		case INITIAL_PROFILE_DETAIL:
			return initialProfileReducer(state)
		default: 
			return state
	}
}

export default headerBar


// WEBPACK FOOTER //
// ./src/store/reducers/headerBar.js